import React, { useEffect, useState, useRef } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { MyAccounts } from "../common/CommonApi";
import { menuItems } from "./common";
import { logout } from "../store/slices/auth";

const ProtectedRoute = ({ children, requiredPermission }) => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const fetchedRef = useRef(false); // ✅ prevents duplicate calls

  useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }

    if (fetchedRef.current) return; // ✅ already fetched once
    fetchedRef.current = true;

    GetMyAccount();
  }, [token]);

  async function GetMyAccount() {
    try {
      const res = await MyAccounts();
      setUser(res);
    } catch (err) {
      console.error("Error fetching account:", err);
      dispatch(logout());
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        Loading...
      </div>
    );
  }

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // --- Permission check ---
  const hasPermission =
    !requiredPermission ||
    user?.permissions?.some(
      (perm) => perm.toLowerCase() === requiredPermission.toLowerCase()
    );

  if (!hasPermission) {
    // Check if user has dashboard permission
    const hasDashboard = user?.permissions?.some(
      (perm) => perm.toLowerCase() === "dashboard"
    );

    if (hasDashboard) {
      return <Navigate to="/dashboard" replace />;
    }

    // ✅ Use menuItems to find a valid route
    const validPermission = user?.permissions?.find((perm) =>
      menuItems.some((item) => item.id.toLowerCase() === perm.toLowerCase())
    );

    const redirectItem = validPermission
      ? menuItems.find(
          (item) => item.id.toLowerCase() === validPermission.toLowerCase()
        )
      : null;

    const redirectPath = redirectItem ? redirectItem.to : "/login";

    return <Navigate to={redirectPath} replace />;
  }

  return children;
};

export default ProtectedRoute;
